import Vue from 'vue'
// import App from './vue_components/App.vue'

import {store} from './store'
// import {router} from './routes'

import VueResource from 'vue-resource'
Vue.use(VueResource);

Vue.http.options.root = '/';

import vSelect from 'vue-select'
Vue.component('v-select', vSelect);

// Set the components prop default to return our fresh components 
vSelect.props.components.default = () => ({
    OpenIndicator: {
        render: createElement => createElement('svg', {
            attrs: {
                width: "12",
                height: "8",
                viewBox: "0 0 12 8",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
            }
        }, [
            createElement('path', {
                attrs: {
                    d: "M1 1L5.70588 7L11 1",
                    stroke: "#2D2D2D"
                }
            }) 
        ]),
    },
});

import ResizeSensor from './assets/js/ResizeSensor.js';
ResizeSensor();

// import VBar from 'v-bar'
// Vue.component('v-bar', VBar)

import vueCustomScrollbar from 'vue-custom-scrollbar'
Vue.component('vue-custom-scrollbar', vueCustomScrollbar);

import MaskedInput from 'vue-masked-input'
Vue.component('masked-input', MaskedInput);

// import callback from '@vueComponent/callback'
// Vue.component('callback', callback);

import VueTextareaAutosize from 'vue-textarea-autosize'
Vue.use(VueTextareaAutosize);

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper);

import VueCookie from 'vue-cookie'
Vue.use(VueCookie);

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
    preLoad: 1.1,
    attempt: 4
});

// import VRuntimeTemplate from 'v-runtime-template'
// Vue.component('callback', VRuntimeTemplate)

const globalOptions = {
        el: '#app',
        store,
        // router,
        // render: h => h(App)
        delimiters: ['${', '}'],
};

let globalData ={
    testBool: false,
    mount: false,
    success: false,
    orderId: null,
    wrong: false,
    callbackState: false,
    oneClickState: false,
    oneClickData: undefined,
    searchState: false,
    headerHide: false,
    headerTop: true,
    prevScrollpos: 0,

    requestDone: undefined,

    loadHeader: false,
    loadPage: false,

    visibleMsgCookies: false,
    pageCollection: false,
    pageMain: false,
    whiteHeader: false,

    preload: true,
    visibleFormPhoto: false, // отправить заявку с фото
    visibleFormPhotoInner: false, // маленькое окно не нашли то, что искали
    visibleFormPrivateOrder: false, // Сделать частный заказ
    sliderMain: null, // слайдер на главной в блоке примеров для интерьера
};

const globalMethods = {
    setTitle(name){
        // задать разметку для названия картины стиль изменяется для первого
        let text = name.split(' ');
        let n = 0; // specify which word we're wrapping. remember that the count starts from 0
        let t = 'span'; // which HTML tag are we going to use as wrapper?
        if (n >= text.length) {return;}
        text[n] = '<' + t + ' class="t-name__first-word">' + text[n] + ' </' + t + '>';
        return text.join(' ');
    },
    openSearch() {
        this.searchState = true;
        this.disableScroll();
    },
    openOneClick(data) {
        this.oneClickState = true;
        this.oneClickData = data;
        this.disableScroll();
    },
    openCallback(form, dataSlider, activeIndexSlide){
        this.callbackState = true;
        this.disableScroll();
        if (form === 'visibleFormPrivateOrder') {
            this.visibleFormPrivateOrder = true;
        }
        if (form === 'visibleFormPhoto') {
            this.visibleFormPhoto = true;
        }
        if (form === 'sliderMain') {
            // let massAfter = dataSlider.filter((item, index) => {return index >= activeIndexSlide});
            // let massBefore = dataSlider.filter((item, index) => {return index < activeIndexSlide});
            // this.sliderMain = massAfter.concat(massBefore);
            this.sliderMain = dataSlider;
            this.$refs.callback.slideToStart(activeIndexSlide);
        }
    },
    closeCallback(){
        this.callbackState = false;
        this.enableScroll();
        this.$refs.callback.close();
    },
    headerScroll(){
        let pageYOffset = window.pageYOffset;
        let delta = this.prevScrollpos - pageYOffset;
        if (delta > 0){
            this.headerHide = false;
        } else if (delta < 0){
            this.headerHide = true;
        }

        this.headerTop = pageYOffset === 0;
        this.prevScrollpos = pageYOffset > 0 ? pageYOffset : 0;
    },
    closeCookies() {
        localStorage.setItem('visibleMsgCookies', 'false');
        this.visibleMsgCookies = false;
    }
};

const globalCreated = (vm) => {
    console.log('Vue created');

    if (!Vue.cookie.get('openFilterFirst')) {
        Vue.cookie.set('openFilterFirst', true, { expires: '1h' });
    }

    if (!Vue.cookie.get('visibleFormPhotoCookies')) {
        setTimeout(() => {
            Vue.cookie.set('visibleFormPhotoCookies', true, { expires: '1h' });
        }, 90000); // 1.5 min
    }

    function isMobile() {
        window.innerWidth < 768 ?
            store.dispatch('UpdateMobileState', true) :
            store.dispatch('UpdateMobileState', false);
    }
    isMobile();
    window.onresize = () => {
        isMobile();
    };
};

const globalMounted = (vm) => {
    console.log('Vue mounted');

    vm.mount = true;
    window.addEventListener('scroll', () => {
        vm.headerScroll();
    });
    setTimeout(() => {
        vm.loadHeader = true;
    }, 300);

    (localStorage.getItem('visibleMsgCookies') === 'false') ?
        vm.visibleMsgCookies = false :
        vm.visibleMsgCookies = true;

    let body = document.querySelector('body');
    body.onmouseleave = (e) => {
        if (Vue.cookie.get('visibleFormPhotoCookies') === 'true') {
            if (!vm.visibleFormPhoto) {
                // if (vm.callbackState && e.clientY <= 0) {
                //     vm.closeCallback();
                // }
                if (e.clientY <= 0 && !vm.callbackState) {
                    vm.visibleFormPhoto = true;
                    vm.visibleFormPhotoInner = true;
                    vm.openCallback();
                    Vue.cookie.set('visibleFormPhotoCookies', false, { expires: '1h' });
                }
            }
        }
    }
};

export {Vue, globalOptions, globalData, globalMethods, globalCreated, globalMounted}


// WEBPACK FOOTER //
// ./src/data.js